// src/themes/modern/menu/components/ViewModeSwitcher.tsx
import { motion } from 'framer-motion';
import React from 'react';
import type { Branch } from '~/types/new_types';
import { useViewMode } from '~/contexts/ViewModeContext';

interface ViewModeSwitcherProps {
	currentMode?: 'grid' | 'list';
	onModeChange?: (mode: 'grid' | 'list') => void;
	theme: Branch['theme'];
}

const ViewModeSwitcher: React.FC<ViewModeSwitcherProps> = ({
	currentMode,
	onModeChange,
	theme
}) => {
	// Fallback to global context if props not provided
	const { viewMode, setViewMode } = useViewMode();
	const effectiveMode = currentMode ?? viewMode;
	const effectiveOnChange = onModeChange ?? setViewMode;
	return (
		<div
			className="flex rounded-lg overflow-hidden"
			style={{ borderRadius: theme.borderRadius }}
		>
			<motion.button
				onClick={() => effectiveOnChange('grid')}
				className="p-3 cursor-pointer"
				whileHover={{ backgroundColor: effectiveMode === 'grid' ? theme.primaryColor : `${theme.primaryColor}30` }}
				whileTap={{ scale: 0.95 }}
				style={{
					backgroundColor: effectiveMode === 'grid' ? theme.primaryColor : `${theme.primaryColor}20`,
					color: effectiveMode === 'grid' ? '#fff' : theme.textColor,
				}}
			>
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect x="3" y="3" width="6" height="6" rx="1" fill="currentColor" />
					<rect x="11" y="3" width="6" height="6" rx="1" fill="currentColor" />
					<rect x="3" y="11" width="6" height="6" rx="1" fill="currentColor" />
					<rect x="11" y="11" width="6" height="6" rx="1" fill="currentColor" />
				</svg>
			</motion.button>

			<motion.button
				onClick={() => effectiveOnChange('list')}
				className="p-3 cursor-pointer"
				whileHover={{ backgroundColor: effectiveMode === 'list' ? theme.primaryColor : `${theme.primaryColor}30` }}
				whileTap={{ scale: 0.95 }}
				style={{
					backgroundColor: effectiveMode === 'list' ? theme.primaryColor : `${theme.primaryColor}20`,
					color: effectiveMode === 'list' ? '#fff' : theme.textColor,
				}}
			>
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect x="3" y="4" width="14" height="2" rx="1" fill="currentColor" />
					<rect x="3" y="9" width="14" height="2" rx="1" fill="currentColor" />
					<rect x="3" y="14" width="14" height="2" rx="1" fill="currentColor" />
				</svg>
			</motion.button>
		</div>
	);
};

export default ViewModeSwitcher;